import { z } from 'zod';
import { environmentNameSchema } from './types/opaque.mjs';

const CommonLibraryConfig = z.object({
    googleAddressApiKey: z.string(),
    environment: environmentNameSchema,
});
let commonLibraryContext;
const initializeCommonLibraryContext = (context) => {
    try {
        CommonLibraryConfig.parse(context.config);
        commonLibraryContext = context;
    }
    catch (error) {
        throw new Error(`Failed to initialize common library context. Error: ${error.message}`);
    }
};
const getCommonLibraryContext = () => {
    if (!commonLibraryContext)
        throw new Error("common library context not initialized");
    return commonLibraryContext;
};

export { CommonLibraryConfig, commonLibraryContext, getCommonLibraryContext, initializeCommonLibraryContext };
